module.exports = __webpack_public_path__ + "img/down-sc1.0116cc40.png";